import { CUSTOM_ELEMENTS_SCHEMA, Component, NgModule, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FormsModule }      from '@angular/forms';
import { DataService } from '../data.service';
import { Player } from '../Main.Model';
//import { format } from "d3-format";

@Component({
    selector: 'app-chart',
    templateUrl: './chart.component.html',
    styleUrls: ['./chart.component.css'],
    standalone: false
})
export class ChartComponent implements OnInit {

  multi: any[] = multi;
  view: any[] = [1400, 700];//size of chart

  // options
  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Date';
  yAxisLabel: string = 'Points';
  timeline: boolean = true;

  SelectedPlayer1: Player = new Player();
  SelectedPlayer2: Player = new Player();

  Minimum: number = 1000;
  Maximum: number = 4000;

  colorScheme = {
    //domain: ['pink', 'purple', 'black', 'green', 'red', 'white']
     domain: ['#5AA454', '#E44D25', '#CFC0BB', '#7aa3e5', '#a8385d', '#aae3f5']
  };

  constructor(public DataService: DataService) {
    Object.assign(this, { multi });
   }

  ngOnInit(): void {
    
    setTimeout(() => {
      this.SelectedPlayer1 = this.DataService.Players[0];
      this.SelectedPlayer2 = this.DataService.Players[1];
      this.playerChanged(this.DataService.Players[0], 1);
    }, 100);
  }

  onSelect(data:any): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data:any): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data:any): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

  playerChanged(Player:any,num:any) {
    //need to make an array of match data with given user involved
    var newData = [
      {
      "name": this.SelectedPlayer1.name,
      "series": this.multi[0].series
      },
      {
        "name": this.SelectedPlayer2.name,
        "series": this.multi[1].series
        }
    ]

    this.DataService.Matches.sort((a , b) => {
      if (a.dateOfMatch > b.dateOfMatch) {
        return 1
      }
      if (a.dateOfMatch < b.dateOfMatch) {
        return -1
      }
      return 0;
    });
    
    newData[num-1].name = Player.name
    newData[num-1].series = [];
    this.DataService.Matches.forEach(match => {
      if (!match.player3 ||match.player3 == 0) {
        if((match.player1 == Player.id && match.newPoints1 > 0) || (match.player2 == Player.id && match.newPoints2 > 0)) {
          var newDataPoint = new DataPoint;
          newDataPoint.name = match.dateOfMatch;
          if (match.player1 == Player.id) {
            newDataPoint.value = match.newPoints1;
          } else {
            newDataPoint.value = match.newPoints2;
          }
          
          newData[num-1].series.push(newDataPoint);
          if (newDataPoint.value > this.Maximum) {
            this.Maximum = newDataPoint.value;
          }
          if (newDataPoint.value < this.Minimum) {
            this.Minimum = newDataPoint.value;
          }
        }
      }
    });
    this.multi = newData;
  }
}

export class DataPoint {
    name: Date = new Date();
    value: number = 0;
}

var multi = [
  {
    "name": "",
    "series": [
      {
      "name": new Date(),
      "value": 1000
      }
    ]
  },
  {
    "name": "",
    "series": [
      {
        "name": new Date(),
        "value": 3000
        }
    ]
}
]

// var multi = [
//   {
//     "name": "Germany",
//     "series": [
//       {
//         "name": "1990",
//         "value": 62000000
//       },
//       {
//         "name": "2010",
//         "value": 73000000
//       },
//       {
//         "name": "2011",
//         "value": 89400000
//       }
//     ]
//   },

//   {
//     "name": "USA",
//     "series": [
//       {
//         "name": "1990",
//         "value": 250000000
//       },
//       {
//         "name": "2010",
//         "value": 309000000
//       },
//       {
//         "name": "2011",
//         "value": 311000000
//       }
//     ]
//   },

//   {
//     "name": "France",
//     "series": [
//       {
//         "name": "1990",
//         "value": 58000000
//       },
//       {
//         "name": "2010",
//         "value": 50000020
//       },
//       {
//         "name": "2011",
//         "value": 58000000
//       }
//     ]
//   },
//   {
//     "name": "UK",
//     "series": [
//       {
//         "name": "1990",
//         "value": 57000000
//       },
//       {
//         "name": "2010",
//         "value": 62000000
//       }
//     ]
//   }
// ];
